/**
 * Builds the width resolvers of a column whose sizes come from `ctx.fields[fieldKey]`
 * (the per-view column preferences). Spread the result into a schema column.
 *
 * @param {string} fieldKey - key inside `ctx.fields`
 * @param {Object} [options]
 * @param {boolean} [options.groupAware=false] - when `ctx.groupBy` is set, `maxWidth` becomes `defaultMin`
 * @param {string} [options.width] - fields property used as the explicit `width` (e.g. 'defaultMin')
 * @return {Object} `{ minWidth, maxWidth, width? }` resolvers
 */
const fieldWidths = (fieldKey, { groupAware = false, width } = {}) => {
  const resolvers = {
    minWidth: ({ fields }) => fields?.[fieldKey]?.minWidth,
    maxWidth: ({ fields, groupBy }) => (groupAware && groupBy
      ? fields?.[fieldKey]?.defaultMin
      : fields?.[fieldKey]?.maxWidth)
  };

  if (width) resolvers.width = ({ fields }) => fields?.[fieldKey]?.[width];

  return resolvers;
};

export default fieldWidths;
